import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialModule } from 'lib/modules/special.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { WebpService } from 'lib/services/webp.service';

@Component({
    selector: 'cms-partial-category-top-component-subcategory-links-v2',
    templateUrl: './subcategory-links-v2.component.html',
    styleUrls: ['./subcategory-links-v2.component.scss'],
    standalone: true,
    imports: [CommonModule, SpecialModule],
})
export class SubcategoryLinksV2Component extends CmsPartialComponentClass {
    @Input() subcategoryLinksV2Row: any;
    getWebpImg: (src: string) => string;
    constructor(webpService: WebpService) {
        super({
            dependencies: {
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }

    ngOnInit() {}
}
